import React from 'react';
const stats = [{
  num: '+15K',
  label: 'La comunidad de +15.000 instructoras 🌎 de habla hispana.'
}, {
  num: '1.200+',
  label: 'Studios y centros de Pilates ya lo usan hoy mismo.'
}, {
  num: '380K+',
  label: 'Rutinas descargadas desde inicio de año.'
}, {
  num: '94%',
  label: 'Ahorra 5h+ de trabajo semanal.'
}];
const standards = ['Diseñado bajo criterios biomecánicos y clínicos.', 'Apto para niveles Inicial, Intermedio y Avanzado.', 'Compatible con tablet, móvil, PC y para imprimir.'];
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-12 sm:py-16 border-y border-border-light px-4 relative overflow-hidden" data-id="element-250">
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/5 to-transparent" data-id="element-251"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-252">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-10 sm:mb-12" data-id="element-253">
          {stats.map((stat, i) => <div key={i} className="text-center" data-id="element-254">
              <div className="text-primary font-black text-2xl sm:text-4xl mb-2 drop-shadow-[0_0_8px_rgba(168,85,247,0.5)]" data-id="element-255">
                {stat.num}
              </div>
              <p className="text-text-sec text-xs sm:text-sm leading-snug" data-id="element-256">
                {stat.label}
              </p>
            </div>)}
        </div>

        <div className="border-t border-border-light pt-8 sm:pt-10" data-id="element-257">
          <p className="text-center text-primary font-bold uppercase tracking-wider text-xs sm:text-sm mb-5" data-id="element-258">
            Estándar profesional
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6" data-id="element-259">
            {standards.map((s, i) => <div key={i} className="flex items-start gap-3 bg-white/5 border border-white/10 rounded-xl px-4 py-3" data-id="element-260">
                <span className="text-check-green text-sm mt-0.5" data-id="element-261">✓</span>
                <p className="text-text-sec text-sm leading-snug" data-id="element-262">{s}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}